// VDOT ADA Curb Ramp inventory snapshot — May 2026
// Source: CRUB_ADA_VA_MAY_2026.json (82,438 features, ArcGIS Hub item c4cfead89d1d4051837b7e6ab523f6aa)

export const STATEWIDE_TOTAL = 82438;

export const DISTRICTS = [
  { name: 'Northern Virginia', count: 69612, color: '#0a0a0a' },
  { name: 'Lynchburg',         count: 3436,  color: '#1F7A8C' },
  { name: 'Richmond',          count: 2855,  color: '#DBC078' },
  { name: 'Fredericksburg',    count: 2062,  color: '#7A1F2B' },
  { name: 'Hampton Roads',     count: 1210,  color: '#2a2a2a' },
  { name: 'Culpeper',          count: 995,   color: '#3a8fa3' },
  { name: 'Salem',             count: 896,   color: '#c4a85a' },
  { name: 'Staunton',          count: 784,   color: '#9a3a4a' },
  { name: 'Bristol',           count: 588,   color: '#6a4a9a' },
];

export const JURISDICTIONS = [
  { code: '029', slug: 'fairfax_county_va',        name: 'Fairfax County',         count: 43611, district: 'Northern Virginia',
    apci: 62, apci_category: 'Fair', noncompliant: 27074, cost_low_m: 37, cost_high_m: 50, vdot_align: 87.4 },
  { code: '076', slug: 'prince_william_county_va', name: 'Prince William County',  count: 12993, district: 'Northern Virginia',
    apci: 64, apci_category: 'Fair', noncompliant: 8070,  cost_low_m: 11, cost_high_m: 15, vdot_align: 86.1 },
  { code: '053', slug: 'loudoun_county_va',        name: 'Loudoun County',         count: 11573, district: 'Northern Virginia',
    apci: 68, apci_category: 'Fair', noncompliant: 6480,  cost_low_m: 10, cost_high_m: 13, vdot_align: 88.7 },
  { code: '013', slug: 'arlington_county_va',      name: 'Arlington County',       count: 4720,  district: 'Northern Virginia',
    apci: 65, apci_category: 'Fair', noncompliant: 2960,  cost_low_m: 4,  cost_high_m: 5,  vdot_align: 88.5 },
  { code: '043', slug: 'henrico_county_va',        name: 'Henrico County',         count: 3210,  district: 'Richmond',
    apci: 63, apci_category: 'Fair', noncompliant: 2010,  cost_low_m: 3,  cost_high_m: 4,  vdot_align: 85.8 },
  { code: '510', slug: 'alexandria_va',            name: 'Alexandria',             count: 2890,  district: 'Northern Virginia',
    apci: 66, apci_category: 'Fair', noncompliant: 1820,  cost_low_m: 2,  cost_high_m: 3,  vdot_align: 89.2 },
  { code: '041', slug: 'chesterfield_county_va',   name: 'Chesterfield County',    count: 2640,  district: 'Richmond',
    apci: 63, apci_category: 'Fair', noncompliant: 1655,  cost_low_m: 2,  cost_high_m: 3,  vdot_align: 85.4 },
  { code: '810', slug: 'virginia_beach_va',        name: 'Virginia Beach',         count: 1090,  district: 'Hampton Roads',
    apci: 64, apci_category: 'Fair', noncompliant: 682,   cost_low_m: 1,  cost_high_m: 1,  vdot_align: 84.6 },
];

export const STATEWIDE_GRADES = [
  { grade: 'A',  label: 'Compliant',    count: 18633, color: '#1F7A8C', desc: 'Truncated dome DWS, width ≥ 48", good material' },
  { grade: 'B',  label: 'Single fail',  count: 22141, color: '#DBC078', desc: 'One PROWAG input fails' },
  { grade: 'C',  label: 'Multi fail',   count: 26764, color: '#c97a3a', desc: 'Multiple PROWAG inputs fail' },
  { grade: 'D',  label: 'Missing',      count: 2348,  color: '#7A1F2B', desc: 'No ramp where one is needed' },
  { grade: 'NA', label: 'N/A',          count: 12552, color: '#999',    desc: 'Ramp not required at this location' },
];

export const DWS_DATA = [
  { name: 'Exposed Aggregate', count: 26754, prowag: false, note: 'Pre-2010 legacy; NOT PROWAG-compliant' },
  { name: 'Truncated Dome',    count: 18633, prowag: true,  note: 'PROWAG R305.1.1 compliant' },
  { name: 'No DWS',            count: 16993, prowag: false, note: 'Required but absent' },
  { name: 'N/A (No Ramp)',     count: 16363, prowag: null,  note: 'Ramp not present' },
  { name: 'Other / Unknown',   count: 3695,  prowag: null,  note: 'Field verification needed' },
];

export const WIDTH_DATA = [
  { name: '< 48" (PROWAG fail)', count: 17128, fail: true },
  { name: '= 48" (PROWAG min)',  count: 45202, fail: false },
  { name: '> 48"',               count: 14310, fail: false },
  { name: '= 0" (no ramp)',      count: 12077, fail: true },
];

export const MATERIAL_DATA = [
  { name: 'Good',      count: 22494, color: '#1F7A8C' },
  { name: 'Fair',      count: 36587, color: '#DBC078' },
  { name: 'Poor',      count: 4747,  color: '#c97a3a' },
  { name: 'Very Poor', count: 883,   color: '#7A1F2B' },
  { name: 'N/A',       count: 13523, color: '#999' },
];

export const COST_CATEGORIES = [
  { category: 'Install (Grade D)',                          count: 2348,  unit_low: 2200, unit_high: 2200 },
  { category: 'Width-fail rebuild',                         count: 17128, unit_low: 2200, unit_high: 2200 },
  { category: 'DWS replace (aggregate→truncated dome)',     count: 26754, unit_low: 500,  unit_high: 1500 },
  { category: 'Material rebuild (Poor/Very Poor)',          count: 5630,  unit_low: 2200, unit_high: 2200 },
];

// Fairfax sample priority findings (illustrative — matches sample DOCX)
export const FAIRFAX_TOP_FINDINGS = [
  { id: 'CR-029-04421', loc: 'NB Ox Road & Lorton Rd, NW corner',     ap_grade: 'C', vdot_grade: 'B',
    issue: 'Running slope 10.4% (PROWAG R304.2.1 max 8.3%); DWS exposed aggregate', cost: 2200, severity: 'major' },
  { id: 'CR-029-04422', loc: 'NB Ox Road & Lorton Rd, NE corner',     ap_grade: 'D', vdot_grade: 'D',
    issue: 'No ramp present where pedestrian access required',                         cost: 2200, severity: 'major' },
  { id: 'CR-029-04425', loc: 'Lorton Rd & Workhouse Way, SW corner',  ap_grade: 'B', vdot_grade: 'A',
    issue: 'Cross slope 2.7% (PROWAG R304.2.2 max 2.1%); VDOT marked compliant 2019', cost: 2200, severity: 'moderate' },
  { id: 'CR-029-04428', loc: 'Workhouse Way & Lorton Rd, NE corner',  ap_grade: 'C', vdot_grade: 'C',
    issue: 'Width 42" (PROWAG R304.5.1.1 min 48"); landing slope 3.1%; methods agree', cost: 2200, severity: 'major' },
  { id: 'CR-029-04432', loc: 'Silverbrook Rd & Ox Rd, SE corner',     ap_grade: 'A', vdot_grade: 'A',
    issue: 'All measurements within PROWAG R304/R305 tolerances; methods agree',       cost: 0,    severity: 'compliant' },
];

export const calcCostRange = (cats = COST_CATEGORIES) => {
  const low  = cats.reduce((s, c) => s + c.count * c.unit_low,  0);
  const high = cats.reduce((s, c) => s + c.count * c.unit_high, 0);
  return { low, high };
};
